module.exports = __webpack_public_path__ + "img/water-green1.a7c98684.png";